module.exports = __webpack_public_path__ + "img/lab-2.ff0b38f5.jpg";